<template>
  <form
    id="contact-form"
    name="contact-form"
    method="post"
    action="/contact"
    @submit.prevent="sendContact"
  >
    <h2 v-if="title">{{ title }}</h2>
    <p class="description" v-if="description">{{ description }}</p>
    <div>
      <div>
        <label for="name">Naam<sup>*</sup></label>
        <input
          id="name"
          class="grey-field"
          type="text"
          v-model="contact.userInfo.name"
          maxlength="256"
          @input="v$.contact.userInfo.name.$touch()"
          :class="{
            invalid:
              v$.contact.userInfo.name.$invalid &&
              v$.contact.userInfo.name.$dirty
          }"
        />
      </div>

      <div class="sec-div">
        <label for="phone">Telefoon</label>
        <input
          id="phone"
          class="grey-field"
          type="text"
          v-model="contact.userInfo.phone"
          maxlength="20"
        />
      </div>
    </div>
    <div>
      <div>
        <label for="email">E-mail<sup>*</sup></label>
        <input
          id="email"
          type="email"
          class="grey-field"
          v-model="contact.userInfo.email"
          maxlength="128"
          @input="v$.contact.userInfo.email.$touch()"
          :class="{
            invalid:
              v$.contact.userInfo.email.$invalid &&
              v$.contact.userInfo.email.$dirty
          }"
        />
      </div>

      <div class="sec-div" v-if="!hideCompany">
        <label for="company">Bedrijf<sup>*</sup></label>
        <input
          id="company"
          type="text"
          class="grey-field"
          v-model="contact.userInfo.company"
          @input="v$.contact.userInfo.company.$touch()"
          :class="{
            invalid:
              v$.contact.userInfo.company.$invalid &&
              v$.contact.userInfo.company.$dirty
          }"
        />
      </div>
    </div>
    <div>
      <label>Bericht<sup>*</sup></label>
      <textarea
        v-model="contact.message"
        @input="v$.contact.message.$touch()"
        class="grey-field"
        :class="{
          invalid: v$.contact.message.$invalid && v$.contact.message.$dirty
        }"
      ></textarea>
    </div>
    <div class="bottom">
      <bouncing-spinner class="spinner" v-show="sending"></bouncing-spinner>
      <span class="succes" v-show="messageSucces"
        >Uw bericht is succesvol verzonden.</span
      >
      <button
        type="submit"
        class="link-button"
        :disabled="v$.contact.$invalid || sending || messageSucces"
        v-show="!sending"
      >
        Verzenden
      </button>
    </div>
  </form>
</template>

<script>
import useVuelidate from '@vuelidate/core'
import { sendMail } from '@/api/api'

import { required, email, requiredIf } from '@vuelidate/validators'

import { format } from 'date-fns'

export default {
  props: {
    recipient: {},
    description: {},
    title: {},
    subject: {},
    conversionId: {},
    hideCompany: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      messageSucces: false,
      contact: {
        userInfo: {
          name: '',
          phone: '',
          email: '',
          company: ''
        },
        message: ''
      },
      sending: false
    }
  },
  setup() {
    const v$ = useVuelidate()
    return { v$ }
  },
  methods: {
    sendContact() {
      this.sending = true

      if (this.subject) {
        this.contact.message = this.subject + '\n' + this.contact.message
      }

      if (this.recipient) {
        this.contact.to = this.recipient
      } else {
        this.contact.to = 'helpdesk@rijnja.nl'
      }

      sendMail(this.contact).then((val) => {
        if (val === true) {
          setTimeout(() => {
            this.sending = false
            this.messageSucces = true
          }, 2000)

          setTimeout(() => {
            this.sending = false
            this.messageSucces = false
            this.contact = {
              userInfo: {
                name: '',
                phone: '',
                email: '',
                company: ''
              },
              message: ''
            }
          }, 4000)
        }
      })
    }
  },
  validations: {
    contact: {
      userInfo: {
        name: {
          required
        },
        email: {
          required,
          email
        },
        company: {
          required: requiredIf(function () {
            return !this.hideCompany
          })
        }
      },
      message: {
        required
      }
    }
  }
}
</script>

<style lang="scss" scoped>
#contact-form {
  border-radius: 15px;
  box-shadow: rgba(0, 0, 0, 0.33) 0 0 28px -12px;
  background: white;
  padding: 40px;
  width: 100%;
  display: inline-block;

  h2 {
    margin: 0 0 25px;
    text-align: left;
  }

  label {
    //font-size: 13px;
    font-weight: 300;
    width: 52px;
    margin-right: 8px;
  }

  .description {
    padding-bottom: 30px;
  }

  > div {
    display: flex;
    //   align-items: baseline;
    flex-wrap: wrap;
    line-height: 34px;

    > div {
      flex-grow: 1;
      display: flex;
      //     align-items: baseline;
    }

    input {
      flex-grow: 1;
      margin-right: 0;
      margin-bottom: 25px;
    }

    textarea {
      flex-grow: 1;
      height: 100px;
      margin-bottom: 10px;
    }
  }
  .bottom {
    justify-content: flex-end;
    margin-bottom: 0;
    align-items: center;
    margin-top: 15px;
    height: 37px;
  }

  .spinner {
    flex-grow: 0;
  }

  .succes {
    padding-right: 15px;
    color: #012169;
  }

  .link-button {
    margin-top: 0;
  }

  .spinner {
    float: right;
    margin-right: 15px;
  }
}

@media only screen and (min-width: 532px) {
  #contact-form {
    > div {
      flex-wrap: unset;
    }
  }

  .sec-div {
    padding-left: 5px;
  }
}
</style>
